import styled from 'styled-components';

type ContainerProps = {
  hoverColor: string;
};

export const Container = styled.div.attrs({
  className: 'flex flex-col bg-white hover:opacity-90 h-[500px] w-[400px]'
})<ContainerProps>`
  .card-heading {
    color: ${(props) => props.hoverColor};
  }
  .card-content:hover {
    background: ${(props) => props.hoverColor};
  }
`;
